(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-options"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
  if (!input.nextElementSibling?.classList.contains('vionix-option')) return;
  const heading = input.closest('varitem')?.querySelector('.current-option');
  if (heading) heading.textContent = input.value;
});
  } catch(e) { console.error(e); }
})();

})();
